module.exports = __webpack_public_path__ + "827189550426029f0bf8ad1b4959f9c2.MP3";